module.exports = __webpack_public_path__ + "img/img40.80971c9a.svg";